import http from './http';
import { IFieldIssue } from '../../../app/models/field_issues';

const BASE_URL= '/field_issues';

export async function fetchAll(): Promise<IFieldIssue[]> {
  const {data} = await http.get(BASE_URL);
  return data;
}

export async function create(item: IFieldIssue): Promise<IFieldIssue> {
  const {data} = await http.post(BASE_URL, item);
  return data;
}

export async function update(item: IFieldIssue): Promise<IFieldIssue> {
  const {data} = await http.put(`${BASE_URL}/${item.entry_id}`, item);
  return data;
}

export async function destroy(item: IFieldIssue): Promise<number> {
  const {status} = await http.delete(`${BASE_URL}/${item.entry_id}`);
  return status;
}

export async function upvote(item: IFieldIssue, userId: string): Promise<IFieldIssue> {
  item.upvoted_by.push(userId);
  const {data} = await http.put(`${BASE_URL}/${item.entry_id}/upvote`);
  return data;
}

export async function unUpvote(item: IFieldIssue, userId: string): Promise<IFieldIssue> {
  item.upvoted_by.splice(item.upvoted_by.indexOf(userId), 1);
  const {data} = await http.delete(`${BASE_URL}/${item.entry_id}/upvote`);
  return data;
}
